import gql from "graphql-tag";

export default gql`
  mutation updateGraphicSet($customerId: ID, $graphicSetId: ID, $graphicSetInput: GraphicSetInputInput) {
    updateGraphicSet(customerId: $customerId, graphicSetId: $graphicSetId, graphicSetInput: $graphicSetInput) {
      id
      customerId
    }
  }
`;
